<script setup>
const props = defineProps({
  name: {
    type: String,
    default: 'name',
  },
  label: {
    type: String,
    required: true,
  },
});

const model = defineModel({ type: String, default: '' });

const { value, errorMessage, handleChange, handleBlur, meta } = useField(
  () => props.name,
  null,
  { initialValue: model.value, validateOnValueUpdate: false },
);

useSyncModels(model, value);

const inputRef = ref(null);
const { focused } = useFocus(inputRef);
</script>

<template>
  <UiFormInputBase
    class="form-textarea"
    :label="label"
    :is-active="focused"
    :error="errorMessage"
  >
    <textarea
      ref="inputRef"
      v-model.trim="value"
      type="text"
      class="form-textarea__textarea"
      :class="{ 'form-textarea__textarea--error': errorMessage }"
      @input="meta.touched && handleChange($event.target.value.trim())"
      @blur="handleBlur($event, true)"
    />
  </UiFormInputBase>
</template>

<style scoped lang="scss">
.form-textarea {
  cursor: text;

  &__textarea {
    flex-grow: 1;
    font-size: em(18);
    line-height: em(20, 18);
    color: $color-black;
    min-height: em(131, 18);

    @include media-breakpoint-down(sm) {
      font-size: em(16);
      line-height: em(18, 16);
      min-height: em(155, 16);
    }

    &--error {
      color: $color-red-1;
    }
  }
}
</style>
